import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import renderField from "components/FormInputs/renderField";
import logoImg from "../../assets/images/logo.png";

const validate = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }
  if (!values.password) {
    errors.password = "Password is required";
  } else if (values.password.length < 6) {
    errors.password = "Must be 6 characters or more";
  }
  return errors;
};

const StackedForm = ({ submitting, handleSubmit, submitForm }) => (
  <div
    className="card"
    style={{
      maxWidth: 480,
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: 32,
      background: "transparent",
      border: "none",
    }}
  >
    <img src={logoImg} alt="logo" width={80} />
    <div className="row" style={{ width: "100%" }}>
      <div>
        <h2
          className="title"
          style={{
            fontSize: 48,
            fontWeight: 700,
            lineHeight: 1.2,
            marginBottom: 12,
            marginTop: 24,
          }}
        >
          Login
        </h2>
        <p
          style={{
            marginBottom: 8,
            fontSize: 32,
            fontWeight: 400,
            lineHeight: 1.2,
          }}
        >
          Welcome back
        </p>
      </div>
    </div>
    <div className="content" style={{ width: "100%", padding: 0 }}>
      <form onSubmit={handleSubmit}>
        <div className="form-group login-input-container">
          <label style={{ fontSize: 16, fontWeight: 400, lineHeight: 1.4 }}>
            Username
          </label>
          <span style={{ fontSize: 16, color: "#C00F0C" }}> *</span>
          <Field
            name="text"
            type="text"
            component={renderField}
            placeholder="Enter username"
            style={{ borderRadius: 8 }}
          />
        </div>

        <div className="form-group login-input-container">
          <label style={{ fontSize: 16, fontWeight: 400, lineHeight: 1.4 }}>
            Password
          </label>
          <span style={{ fontSize: 16, color: "#C00F0C" }}> *</span>
          <Field
            name="password"
            type="password"
            component={renderField}
            placeholder="Enter password"
            style={{ borderRadius: 8 }}
            className="login-input"
          />
        </div>
        <div
          className="form-group login-checkbox-container"
          style={{ marginBottom: 32 }}
        >
          <Field
            name="checkbox1"
            type="checkbox"
            label="Stay signed in"
            component={renderField}
          />
        </div>

        <button
          type="submit"
          className="btn btn-fill btn-info"
          style={{
            borderRadius: "5px",
            width: "100%",
            background: "#E8B931",
            border: "none",
            height: 48,
            fontSize: 16,
            fontWeight: 600,
            color: "#2C2C2C",
          }}
          disabled={submitting}
        >
          Đăng nhập
        </button>
      </form>
    </div>
  </div>
);

export default reduxForm({
  form: "stackedForm",
  validate,
})(StackedForm);



// WEBPACK FOOTER //
// ./src/pages/Login/LoginForm.js